/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import moment from "moment-timezone";

const superagent = superagentPromise(_superagent, global.Promise);
let API_ROOT = "";
if (process.env.NODE_ENV === "production") {
  API_ROOT = process.env.REACT_APP_API_ROOT;
} else {
  API_ROOT = process.env.REACT_APP_API_ROOT;
}

const responseBody = (res) => res.body;

// let token = null;
const tokenPlugin = (req) => {
  const token = localStorage.getItem("token");
  // SETTING USER CURRENT TIMEZONE
  req.set("x-user-timezone", moment.tz.guess());

  if (token) {
    req.set("authorization", `Token ${token}`);
  }
};

const omitSlug = (data) => {
  delete data.slug;
  return data;
};
const omitSlugAndQueryParams = (data) => {
  delete data.slug;
  delete data.query;
  return data;
};

const requests = {
  del: (url, body) =>
    superagent
      .del(`${API_ROOT}${url}`)
      .send(body)
      .use(tokenPlugin)
      .then(responseBody),
  get: (url) =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  postWithFile: (url, fieldname, files, fields) => {
    let req = superagent.post(`${API_ROOT}${url}`);
    // if(Array.isArray(files))
    Object.keys(fields).forEach((fieldName) => {
      req.field(fieldName, fields[fieldName]);
    });
    files.forEach((file) => req.attach(fieldname, file));
    return req.use(tokenPlugin).then(responseBody);
  },
  uploadFile: (url, payload, reqFieldName = "file") => {
    let req = superagent.post(`${API_ROOT}${url}`);
    const { files, ...otherParams } = payload;
    const isFileList =
      Object.prototype.toString.call(files) === "[object FileList]";
    let filesArray = [];

    if (isFileList) filesArray = Object.values(files);
    else if (Array.isArray(files)) filesArray = files;
    else filesArray.push(files);

    Object.keys(otherParams).forEach((fieldName) => {
      req.field(fieldName, otherParams[fieldName]);
    });

    filesArray.forEach((file) => req.attach(reqFieldName, file));

    return req.use(tokenPlugin).then(responseBody);
  },
  getFile: (url) =>
    superagent.get(`${API_ROOT}${url}`).responseType("blob").use(tokenPlugin),
};

const Auth = {
  current: () => requests.get("/user"),
  login: (userData) => requests.post("/users/login", userData),
  signup: (userData) => requests.post("/users/register", userData),
  validateToken: () => {
    return requests.get("/users/checkToken");
  },
  googleLogin: (gtoken) =>
    requests.post("/users/googleLogin", { token: gtoken }),
  activateUser: (userData) => {
    return requests.post("/users/checkactivationcode", userData);
  },
  forgotpassword: (userData) => {
    return requests.post("/users/forgotpassword", userData);
  },
  resetpassword: (userData) => {
    return requests.post("/users/resetpassword", userData);
  },
  userDetail: () => {
    return requests.get("/users/detail");
  },
  updateUserDetail: (userData) => {
    return requests.put("/users/detail", userData);
  },
  saveInvestorProfile: (userData) => {
    return requests.post("/users/saveInvestorProfile", userData);
  },
  updateInvestorProfile: (userData) => {
    return requests.post("/users/updateInvestorProfile", userData);
  },

  resendActivationEmail: (email) =>
    requests.post("/users/resendActivationEmail", { email: email }),

  saveFilter: (userData) => {
    return requests.post("/users/save_filter", { data: userData });
  },
};

const AssetRequests = {
  assetListing: () => requests.get("/users/assets_list"),
  saveAsset: (assetData) => {
    return requests.post("/assets/addProperty", { data: assetData });
  },
  addAssetAndFinancials: (assetData) => {
    return requests.post("/assets/addAssetAndFinancials", { data: assetData });
  },
  assetDetailing: (asset_id) =>
    requests.get(`/assets/fetchAssetDetail/${asset_id}`),

  getBasicInfo: (data) =>
    requests.get(
      `/users/contacts/${data.contactSlug}/assets/${data.slug}/getBasicInfo`
    ),
  updateBasicInfo: (assetData) =>
    requests.put(`/assets/${assetData.slug}/editBasicInfo`, {
      data: omitSlug(assetData),
    }),

  getInvestmentInfo: (slug) =>
    requests.get(`/assets/${slug}/getInvestmentInfo`),
  updateInvestmentInfo: (assetData) =>
    requests.put(`/assets/${assetData.slug}/editInvestmentInfo`, {
      data: omitSlug(assetData),
    }),

  //Get Bank details of asset

  getAccountDetail: (slug) => requests.get(`/assets/${slug}/accountDetails`),

  deleteAsset: (data) =>
    requests.del(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}`,
      { data: omitSlug(data) }
    ),
  // suggestContacts: () => requests.get(`/assets/suggestContacts`),
  // addInsurance: (insuranceDetails) => requests.get(`/assets/${insuranceDetails.slug}/addInsurance`),
  addBankToAsset: (data) =>
    requests.post(`/assets/${data.slug}/linkBankAccount`, {
      data: omitSlug(data),
    }),
  removeBankFromAsset: (data) =>
    requests.post(`/assets/${data.slug}/unlinkBankAccount`, {
      data: omitSlug(data),
    }),
  unlinkAssets: (data) => requests.put(`/assets/unlink/`, { data: data }),

  getMedias: (slug) => requests.get(`/assets/${slug}/medias`),
  addMedias: (data) =>
    requests.uploadFile(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/medias/add`,
      omitSlug(data),
      "medias"
    ),

  deleteMedia: (data) =>
    requests.del(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/medias/${data.fileId}/delete`
    ),
  // uploadImagesToS3: (data) => {
  //   const { slug, fileName, files } = data;
  //   return requests.postWithFile(`/assets/${slug}/attachments`, { data: { slug: slug } }, fileName, files)
  // },

  // saveInsuranceToAsset: (asset_data) => requests.post(`/assets/${asset_data.asset_name}/addinsurance`, { data: asset_data }),
  // getInsuranceToAsset: (asset_data) => requests.get(`/assets/${asset_data.asset_name}/getInsuranceDetail`),

  // setTaxDueDateToAsset: (asset_data) => requests.post(`/assets/${asset_data.slug}/addTaxDueDateToAsset`, { data: asset_data }),

  getAssetExpenses: (data) => requests.get(`/assets/${data.slug}/expenses`),
  getAssetIncomes: (data) => requests.get(`/assets/${data.slug}/incomes`),
  getAssetValuation: (data) => requests.get(`/assets/${data.slug}/valuation`),
  getAssetCashflow: (data) => requests.get(`/assets/${data.slug}/cashflow`),
  getMonthlyOverallCashflow: (data) =>
    requests.get(`/users/monthlyOverallCashflow`),
  getAssetMonthwiseExpenses: (data) =>
    requests.get(`/assets/${data.slug}/expenses/monthwise`),
  getAssetMonthwiseIncomes: (data) =>
    requests.get(`/assets/${data.slug}/incomes/monthwise`),
  hasAsset: (slug) => requests.get(`/assets/${slug}/hasAsset`),
  getAssetStats: (data) => requests.get(`/assets/${data.slug}/assetStats`),
  // getTotalMonthlyStats: () => requests.get(`/users/totalMonthlyStats`),
  getDashboardStats: () => requests.get(`/users/dashboardStats`),
  exportToExcel: ({ slug }) =>
    requests.getFile(`/assets/${slug}/export`).then(responseBody),
  getMonthlyGraph: (data) => requests.get(`/assets/${data.slug}/monthlyGraph`),
  getYearlyGraph: (data) => requests.get(`/assets/${data.slug}/yearlyGraph`),
  getCashFlowGraph: (data) =>
    requests.post(`/assets/${data.slug}/cashFlowGraph`, {
      data: omitSlug(data),
    }),
  updateIncomeGoal: (data) => requests.put(`/users/incomeGoal`, data),

  getChecklist: (slug) => requests.get(`/assets/${slug}/checklist`),

  bulkAddAsset: (data) => requests.uploadFile(`/assets/bulkAdd`, data),
  bulkAddClient: (data) => {
    return requests.post(`/users/contacts/bulkAdd`, { data });
  },
  downloadBulkAddCSV: (data) =>
    requests.getFile(`/users/contacts/sampleBulkAddCsv`).then(responseBody),
  downloadAssetsBulkAddCSV: (data) =>
    requests.getFile(`/assets/sampleBulkAddCsv`).then(responseBody),
};

const Financial = {
  addFinancialToAsset: (data) =>
    requests.post(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/financial`,
      {
        data: omitSlug(data),
      }
    ),
  getAssetFinancials: (data) =>
    requests.get(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/financial`
    ),
  updateAssetFinancial: (data) =>
    requests.put(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/financial`,
      { data: omitSlug(data) }
    ),
  deleteAssetFinancial: (data) =>
    requests.del(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/financial/${data.id}`
    ),
};

const Tenent = {
  getAssetTenents: (tenentData) =>
    requests.get(`/assets/${tenentData.slug}/tenents/get`),
  addAssetTenent: (tenentData) =>
    requests.post(`/assets/${tenentData.slug}/tenents/add`, {
      data: omitSlug(tenentData),
    }),
  updateAssetTenent: (tenentData) =>
    requests.put(`/assets/${tenentData.slug}/tenents/update`, {
      data: omitSlug(tenentData),
    }),
  deleteAssetTenent: (tenentData) =>
    requests.del(`/assets/${tenentData.slug}/tenents/delete`, {
      data: omitSlug(tenentData),
    }),
};

const ContactAsset = {
  addAssetContact: (contactData, slug) =>
    requests.post(`/users/contacts/${slug}/assets`, {
      data: omitSlug(contactData),
    }),
  getAssets: (slug, page) =>
    requests.get(`/users/contacts/${slug}/assets?limit=10&skip=${page * 10}`),
  addAssetDocument: (data, params) =>
    requests.postWithFile(
      `/users/contacts/${data.clientSlug}/assets/${data.assetSlug}/attachments/add`,
      data.fileName,
      data.files,
      params
    ),
  savePartnerTransactions: (data, clientSlug, assetSlug) =>
    requests.post(
      `/users/contacts/${clientSlug}/assets/${assetSlug}/transactions/add`,
      omitSlug(data)
    ),
  bulkAddClientAssets: (data) =>
    requests.uploadFile(
      `/users/contacts/${data.clientSlug}/assets/bulkAdd`,
      data
    ),
  manualBulkAddAssets: (data) =>
    requests.post(`/assets/bulkAddByPartner`, { data }),
};

const Contact = {
  getContact: (slug) => requests.get(`/users/contacts/${slug}`),
  getAllContacts: (page) =>
    requests.get(`/users/contacts?limit=5&skip=${page * 5}`),
  addContact: (contactData) =>
    requests.post("/users/contacts", omitSlug(contactData)),
  deleteContact: (slug) => requests.del(`/users/contacts/${slug}`),
  editContact: (data, slug) =>
    requests.put(`/users/contacts/${slug}`, omitSlug(data)),

  downloadClientAssetsTransactionExcel: (clientSlug, assetsSlug) =>
    requests
      .getFile(`/users/contacts/${clientSlug}/assets/${assetsSlug}/sampleCsv`)
      .then(responseBody),

  parseBulkAddContactsCsv: (data) => {
    return requests.uploadFile(`/users/contacts/parseBulkAddCsv`, data.file);
  },
  parseBulkAddContactsAssetsCsv: (data) => {
    return requests.uploadFile(`/assets/parseAddByPartnerCsv`, data.file);
  },
  requestPermission: (slug, personalNote) =>
    requests.post(`/users/contacts/${slug}/request_permission`, {
      personal_note: personalNote,
    }),
};

const Transaction = {
  getTransactions: (data) =>
    requests.get(
      `/users/contacts/${data.contactSlug}/assets/${data.slug}/transactions?${data.query}`
    ),
  getTransactionsFromBank: (data) =>
    requests.get(`/users/transactions/bank/${data.account_id}`),
  saveTransactions: (data, clientSlug, assetSlug) =>
    requests.post(
      `/users/contacts/${clientSlug}/assets/${assetSlug}/transactions/add`,
      data
    ),

  updateTransaction: (data, contactSlug, assetSlug) =>
    requests.put(
      `/users/contacts/${contactSlug}/assets/${assetSlug}/transactions/update?${data.query}`,
      omitSlugAndQueryParams(data)
    ),
  deleteMultiTransaction: (data) =>
    requests.del(`/assets/${data.slug}/transactions/multidelete`, {
      data: omitSlug(data.data),
    }),
  deleteTransaction: (data) =>
    requests.del(
      `/users/contacts/${data.contactSlug}/assets/${data.slug}/transactions/delete?${data.query}`,
      {
        data: omitSlugAndQueryParams(data),
      }
    ),
  downloadSampleCSV: (data) =>
    requests.getFile(`/assets/${data.slug}/sampleCsv`).then(responseBody),
  downloadPastSampleXLSX: (data) =>
    requests.getFile(`/assets/${data.slug}/pastSampleCsv`).then(responseBody),
  markAllPaid: (data) =>
    requests.put(
      `/users/contacts/${data.contactSlug}/assets/${data.slug}/transactions/markAllPaid`
    ),
  removeAllDuplicates: (data) =>
    requests.put(
      `/users/contacts/${data.contactSlug}/assets/${data.slug}/transactions/removeAllDuplicates`
    ),
};

const User = {
  getOverview: () => requests.get(`/users/overview`),
  getOverallCashflow: (data) =>
    requests.post(`/users/overallCashflow`, {
      data: omitSlug(data),
    }),
  getStats: () => requests.get("/users/partnerDashboardStats"),
};

const Mortgage = {
  saveMortgage: (data) =>
    requests.post(`/assets/${data.slug}/mortgage/add`, data),
  getMortgage: (data) => requests.get(`/assets/${data}/mortgage/get`),
};
const Attachments = {
  saveAttachments: (data, params) =>
    requests.postWithFile(
      `/users/contacts/${data.clientSlug}/assets/${data.assetSlug}/attachments/add`,
      data.fileName,
      data.files,
      params
    ),
  getAttachments: (data) =>
    requests.get(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/attachments`
    ),
  getAttachmentUrl: (data) =>
    requests.get(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/attachments/${data._id}`
    ),
  deleteAttachment: (data) =>
    requests.del(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/attachments/${data.id}/delete`
    ),
  addTags: (data) =>
    requests.put(
      `/users/contacts/${data.contactSlug}/assets/${data.assetSlug}/attachments/${data.id}/addTags`,
      {
        tags: data.tags,
      }
    ),
};

const Rets = {
  getAsset: (address) =>
    requests.get(`/assets/fetchFromRets?address=${address}`),
  lookupAsset: (address) =>
    requests.get(`/assets/lookupAsset?address=${address}`),
  lookupParcel: (parcelID) =>
    requests.get(`/assets/lookupParcel?parcelID=${parcelID}`),
};

const Account = {
  getAccounts: () => requests.get(`/accounts`),
  addAccount: (plaidData) => requests.post(`/accounts/add`, plaidData),
  deleteAccount: (data) => requests.del(`/accounts/${data._id}`),
};

// const setAuthToken = (_token) => { token = _token; }

const CMSContent = {
  getPolicyContent: () => requests.get(`/cms/getPolicyContent`),
  getFaqContent: () => requests.get(`/cms/getPolicyContent`),
  getAboutusContent: () => requests.get(`/cms/getPolicyContent`),
  saveFeedback: (feedback) => requests.post(`/cms/saveFeedback`, feedback),
};

const Resources = {
  getResources: (query) => requests.get(`/cms/resources?type=${query}`),
  reserveResource: (resource) =>
    requests.put(`/cms/resources/${resource}/reserve`),
  getResourceStats: () => requests.get(`/cms/resources/stats`),

  getMyResources: (query) =>
    requests.get(
      `/cms/resources/myresources?type=${query.type}&userId=${query.userId}`
    ),
  getMyResourceStats: (query) =>
    requests.get(`/cms/resources/myresources/stats?userId=${query.userId}`),
  postResource: (data) => requests.post(`/cms/resources/create`, data),
  uploadFile: (data) => requests.uploadFile("/cms/resources/uploadFile", data),
  uploadFiles: (data) =>
    requests.uploadFile("/cms/resources/uploadFiles", data),

  getViewResource: (slug) => requests.get(`/cms/resources/${slug}/get`),
  // updateResource
};

const Recommendations = {
  getRecommendations: () => requests.get(`/cms/recommendations`),
};

const Notifications = {
  getNotications: () => requests.get(`/notifications/`),
  // markNotificationAsCompleted: (data) => requests.put(`/notifications/${data.notiId}`,data),
  // addNotification: (data) => requests.post(`/notifications/add`, data),
};

const Logs = {
  saveAssetNotFoundLog: (address) =>
    requests.post("/users/saveNotFoundAssetLog", { address }),
};

const Invite = {
  sendInvite: (slug, personalNote) =>
    requests.post(`/users/contacts/${slug}/send_invite`, {
      personal_note: personalNote,
    }),
};

const Deal = {
  addDeal: (data) => requests.put(`/deals/${data.slug}`, { ...data }),
  getDeals: (type) => requests.get(`/deals?type=${type}`),
  getMyDeals: (query) => requests.get(`/deals/mydeals?userId=${query.userId}`),
  transferAsset: (data) =>
    requests.put(`/deals/${data.slug}/transfer`, { ...data }),
};

const PropertyManagement = {
  uploadFile: (data) =>
    requests.uploadFile(
      `/assets/myassetname/importManagementTransaction?type=${data.parseType}`,
      data.file
    ),
};

const Reminder = {
  getReminders: () => requests.get(`/reminders/`),
  updateReminder: (data) => requests.put(`/reminders/${data.remId}`, data),
  addReminder: (data) => requests.post(`/reminders/add`, data),
};

const Partner = {
  signup: (data) => requests.post(`/users/partners/add`, data),
  updatePartner: (data) =>
    requests.put(`/users/partners/${data.slug}/update`, data),
  getPartner: (slug) => requests.get(`/users/partners/${slug}`),
  listPartners: (query) => requests.get(`/users/partners?type=${query}`),
};

const Testimonial = {
  request: (slug, personalNote) =>
    requests.post(`/users/contacts/${slug}/request_testimonial`, {
      personal_note: personalNote,
    }),
};

const Opportunities = {
  getOpportunities: (page, searchValue = "") =>
    requests.get(
      `/users/my-opportunities?limit=5&skip=${
        (!searchValue ? page : 0) * 5
      }&search=${searchValue}`
    ),
  addOpportunity: (data) => requests.post(`/users/opportunities/add`, data),
  getOpportunity: (slug) => requests.get(`/users/opportunities/${slug}`),
  editOpportunity: (data, slug) =>
    requests.put(`/users/opportunities/${slug}`, data),
  deleteOpportunity: (slug) => requests.del(`/users/opportunities/${slug}`),
};

const Importer = {
  getImporters: (data) =>
    requests.get(
      `/users/contacts/${data.slug}/importers?limit=10&skip=${data.page * 10}`
    ),
  addImporter: (data) =>
    requests.post(`/users/contacts/${data.slug}/importers`, omitSlug(data)),
  deleteImporter: (data) =>
    requests.del(`/users/contacts/${data.slug}/importers/${data.id}`),
  parseFile: (data) =>
    requests.uploadFile(
      `/users/contacts/${data.slug}/importers/${data.id}/parseFile`,
      data.files
    ),
};

const Integration = {
  getIntegrations: (data) =>
    requests.get(`/users/integrations?limit=10&skip=${data.page * 10}`),
  addIntegration: (data) => requests.post(`/users/integrations`, data),
  updateIntegration: (data) =>
    requests.put(`/users/integrations/${data.id}`, data),
  deleteIntegration: (data) => requests.del(`/users/integrations/${data.id}`),
  syncIntegration: (data) =>
    requests.post(`/users/integrations/${data.id}/sync`, data),
};

export {
  API_ROOT,
  Auth,
  // setAuthToken,
  AssetRequests,
  Rets,
  Attachments,
  Account,
  CMSContent,
  Notifications,
  Transaction,
  User,
  Mortgage,
  ContactAsset,
  Tenent,
  Financial,
  Resources,
  Recommendations,
  Logs,
  Invite,
  Deal,
  PropertyManagement,
  Reminder,
  Partner,
  Contact,
  Testimonial,
  Opportunities,
  Importer,
  Integration,
};
